import { SalesOrderItemType } from '../constants/sales-order-item-type.js';
import { lineFamilyOf } from './line-family.js';
/**
 * True when every family-bearing line on the order is Promo type, and at least one such line
 * exists. Clear Balance treats a promo-only order like a sample order -- no real AR to collect --
 * but a normal sales order mixing Sale and Promo lines does not qualify.
 */
export function isPromoOnlyOrder(items) {
    const familyBearing = items.filter((item) => lineFamilyOf(item.typeId) !== null);
    if (familyBearing.length === 0)
        return false;
    // Can't delegate to lineFamilyOf here the way isSampleOrder does: it deliberately maps
    // Sale and Promo to the same 'sales' family so canAddLineType's mixing rule treats them as
    // interchangeable. Promo-only-ness is a finer distinction within that family, so it has to
    // compare the raw type.
    return familyBearing.every((item) => item.typeId === SalesOrderItemType.PROMO);
}
//# sourceMappingURL=is-promo-only-order.js.map